import axios from 'axios';
import { Snippet } from './snippet';

export class SnippetShow {
  public static async getData(id: number): Promise<any> {
    return axios.get(`/api/snippets/${id}`);
  }

  public static async deleteData(id: number): Promise<any> {
    return axios.delete(`/api/snippets/${id}`);
  }

  public static async saveData(snippetData: Snippet): Promise<any> {
    if (snippetData.id === -1) {
      return axios.post('/api/snippets', {
        snippet: snippetData,
      });
    }
    return axios.put(`/api/snippets/${snippetData.id}`, {
      snippet: snippetData,
    });
  }

  public static parseResponse(response: any): Snippet {
    const snippet = {} as Snippet;
    snippet.id = response.data.id;
    snippet.key = response.data.key;
    snippet.content = response.data.content;
    snippet.updatedAt = new Date(response.data.updated_at);
    return snippet;
  }
}
